import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { InstallationMenuDetailPageRoutingModule } from './installation-menu-detail-routing.module';

import { InstallationMenuDetailPage } from './installation-menu-detail.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    InstallationMenuDetailPageRoutingModule
  ],
  declarations: [InstallationMenuDetailPage]
})
export class InstallationMenuDetailPageModule {}
